<template>
  <v-data-table
    dense
    disable-pagination
    hide-default-footer
    :headers="headers"
    :items="sessions"
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
  >
    <template v-slot:[`item.scheduledDate`]="{ value }">
      {{ value | formatDate }}
    </template>
  </v-data-table>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'TraineeSessionsTable',

  props: {
    personId: {
      type: String,
      required: true
    }
  },

  data: () => ({
    sessions: [],
    headers: [
      { text: 'Date', value: 'scheduledDate' },
      { text: 'Venue', value: 'venue' },
      { text: 'Module', value: 'module.code' },
      { text: 'Trainer', value: 'trainer.person.name' }
    ],
    sortBy: 'scheduledDate',
    sortDesc: true
  }),

  apollo: {
    sessions: {
      query: gql`query TraineeSessions($filter: FilterFindManyTrainingSessionInput) {
        sessions: trainingSessionMany(limit: 0, filter: $filter) {
          _id
          scheduledDate
          completionDate
          venue
          module {
            _id
            code
          }
          trainer {
            _id
            person {
              _id
              name
            }
          }
        }
      }`,
      variables () {
        return {
          filter: {
            trainees: {
              personId: this.personId
            }
          }
        }
      },
      error (e) {
        this.onError(e)
      }
    }
  },

  methods: {
    onError (e) {
      this.$emit('error', e)
    }
  }
}
</script>
